export const VACANCY_POSITION = 'position/vacancy/'
export const VACANCY_POSITION_ALL = `${VACANCY_POSITION}all`
export const VACANCY_POSITION_ACTIVATE = `${VACANCY_POSITION}activate/`
export const VACANCY_POSITION_OPEN = `${VACANCY_POSITION}open/`
export const VACANCY_POSITION_CLOSE = `${VACANCY_POSITION}close/`
